
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc/pre-pattern",
      function () {
        return require("private-next-pages/tnpsc/pre-pattern.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc/pre-pattern"])
      });
    }
  